<template>

<app-content :loading="is.loading">

	<app-content-head :title="title" :back="$route.meta.back" :readonly="$authorised('con/volunteers/access', 'read')">

		<app-content-head-actions-item :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" tooltip="Undo changes" />
		
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" tooltip="Save changes" />
		
		<app-content-head-actions-item v-if="!isNew" :divide="true" :disabled="isNew" :danger="true" icon="retract" text="Retract" v-on:click="onRetractClick" tooltip="Retract pre-approval" />

	</app-content-head>

	<app-content-body v-if="!is.loading">

		<app-content-summary v-if="!isNew">

			<app-content-summary-item :is-fixed="true" label="Status" :tag="$constants.volunteers.approval.statusName[item.status]" :status="$constants.volunteers.approval.statusTheme[item.status]" :theme="$constants.volunteers.approval.statusTheme[item.status]" />

			<app-content-summary-item :is-fixed="true" label="Reference" :value="item.reference" />

			<app-content-summary-item :is-end="!item.date" :grow="true" label="Volunteer" type="convention/badge" :item="item.badge" />

			<app-content-summary-item :is-end="true" label="Approved on" :value="item.date | localDate('MM/DD/YYYY')" v-if="item.date" />

			<app-content-summary-item :is-start="true" :is-metric="true" label="Assignment" :value="item.count.assignments" alt="0" :link="{ name: 'Convention.Volunteers.Badges.Edit', params: { id: item.badge.id } }" tooltip="Click to view assignments" />
			
		</app-content-summary>

		<app-content-box :readonly="$authorised('con/volunteers/access', 'read')">

			<app-input-suggest v-if="isNew" label="Badge" placeholder="Search badges..." v-model="model.badge" api="convention/badge" :validation="$v.model.badge" />
			
			<app-input-checklist :fullWidth="true" :singular="true" :collapsed="!isNew" :columns="1" label="Roles" v-model="model.type" :validation="$v.model.type" :options="$constants.volunteers.whitelist.typeName" :descriptions="$constants.volunteers.whitelist.typeDescription" />

			<app-input-checklist :fullWidth="true" :columns="4" :theme="rolesTheme" :label="rolesLabel" v-model="model.roles" :validation="$v.model.roles" :options="$util.options(references.roles, 'name', 'id')" v-if="isListing" />

		</app-content-box>

		<app-content-section v-if="!isNew" route="Convention.Volunteers.Badges.Edit" :params="{ id: item.badge.id }" title="Assignments" description="View and manage the slots this volunteer has been assigned to." :count="item.count.assignments" :force-count="true" />

	</app-content-body>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'
import { required } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			readonly: this.$authorised('con/volunteers/access', 'read'),
			references: {
				roles: []
			},
			model: {
				id: false,
				badge: false,
				type: this.$constants.volunteers.whitelist.type.all,
				roles: []
			}
		}

	},

	validations: {
		model: {
			badge: {
				required
			}
		}
	},

	computed: {

		isListing: function() {
		
			return this.$_.contains([
				this.$constants.volunteers.whitelist.type.whitelist,
				this.$constants.volunteers.whitelist.type.blacklist
			], this.model.type)

		},

		rolesTheme: function() {
		
			return (this.model.type === this.$constants.volunteers.whitelist.type.whitelist) ? 'green' : 'red'

		},

		rolesLabel: function() {
		
			return (this.model.type === this.$constants.volunteers.whitelist.type.whitelist) ? 'Allowed' : 'Blocked'

		},

		title: function() {

			return (this.isNew) ? 'Add pre-approval' : 'Manage pre-approval'
		
		}

	},

	methods: {

		onSaved: function() {

			this.$router.push({
				name: this.$route.meta.back
			})

		},

		onRetractClick: function() {
		
			this.$router.push({
				name: 'Convention.Volunteers.Approval.Retract'
			})
		
		}

	}

}

</script>

<style scoped>

</style>